/** @type {string} */
const buttonComponent = "Button";
export default buttonComponent;
